import { Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetExpectedCommissions } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

type TProps = {
  applicationId: string;
  offerId?: string;
  isLoadingPayments: boolean;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
};

export const RepeatCommission = ({
  applicationId,
  offerId,
  isLoadingPayments,
  offerIsSelected,
  offerNotSelected,
}: TProps) => {
  const { introducerId } = useIntroducerContext();
  const { formatPercentage } = useNumberFormat();

  const { data: expectedCommission, isFetching } = useGetExpectedCommissions(
    introducerId,
    applicationId,
    offerId,
  );

  const formatCommissionRate = () => {
    if (!expectedCommission?.data) {
      return '-';
    }

    const { repeat_rate } = expectedCommission.data;
    return (
      <div className={styles.expectedCommissionValueContainer}>
        {formatPercentage(repeat_rate)}
      </div>
    );
  };

  return (
    <div
      className={clsx(styles.expectedCommissionContainer, {
        [styles.selectedValue]: offerIsSelected,
        [styles.unselectedValue]: offerNotSelected,
      })}
    >
      {isLoadingPayments || isFetching ? (
        <div
          className={styles.loaderContainer}
          data-testid="expected-commission-spinner"
        >
          <Spinner />
        </div>
      ) : (
        <p className={styles.value}>{formatCommissionRate()}</p>
      )}
    </div>
  );
};
